

































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import DocUploadBlock from '@/componentsV2/molecules/Inputs/DocUploadBlock.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';

enum EActiveLoyalty {
  YES = 'yes',
  NO = 'no'
}

@Component({
  components: {
    FilledButton,
    SelectionBox,
    Typography,
    DocUploadBlock,
    Input,
    ValidationObserver,
    ValidationProvider
  }
})
export default class FormInviteCustomer extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  activeLoyalty = '';
  EActiveLoyalty = EActiveLoyalty;

  formData = {
    spreadsheet: {
      docFile: '',
      docUrl: '',
      docName: ''
    },
    howThisWork: ''
  };

  get tPrefix() {
    return 'inviteCustomerInStore.form';
  }

  get hasActiveLoyalty() {
    return this.activeLoyalty === EActiveLoyalty.YES;
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');

      return;
    }

    this.$emit('finished');
  }
}
